import { render } from "./MultipleSelectInput.vue?vue&type=template&id=6454c88d"
import script from "./MultipleSelectInput.vue?vue&type=script&lang=js"
export * from "./MultipleSelectInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/multidatingdie/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__